/**
 * @generated SignedSource<<b3ae2d56e7b57bae79478dd91931a77d>>
 * @relayHash ef95f5a1d316f5b16b1a97e117953135
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID ef95f5a1d316f5b16b1a97e117953135

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "GenerateManagerFileStatusMutationResponse",
    "kind": "LinkedField",
    "name": "makeDuplicataStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusError",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MakeDuplicataStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MakeDuplicataStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ef95f5a1d316f5b16b1a97e117953135",
    "metadata": {},
    "name": "MakeDuplicataStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "b11a6afb68ab0bcfc9e085e23d6981f4";

export default node;
